import { render, staticRenderFns } from "./TituloRematricula.vue?vue&type=template&id=b99562ce&"
import script from "./TituloRematricula.vue?vue&type=script&lang=js&"
export * from "./TituloRematricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports